<mat-card class="mat-elevation-z4 panel"  cdkDrag>
    <mat-card-header class="header w-100" cdkDragHandle>
        <mat-card-title>
            <span>List of aois with coverage in the center of the view extent</span>
            <mat-form-field>
                <mat-label>Filter aois...</mat-label>
                <input matInput (keyup)="filter($event)" placeholder="name, layer..."
                       #input>
            </mat-form-field>
        </mat-card-title>
        <button class="close" matIconButton aria-label="Close" (click)="close()"><mat-icon>close</mat-icon></button>
    </mat-card-header>
    <mat-card-content class="container">
        <div class="row ">
            <div class="form-container p-2">


                <div class="mat-elevation-z8">
                    <table class="table" mat-table [dataSource]="dataSource" matSort
                           multiTemplateDataRows>

                        <!-- LAYER Column -->
                        <ng-container matColumnDef="layer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Layer</th>
                            <td mat-cell *matCellDef="let row"> {{row.getLayer()}} </td>
                        </ng-container>
                        <ng-container matColumnDef="parent">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Parent</th>
                            <td mat-cell *matCellDef="let row"> {{row.getParentAOI()}} </td>
                        </ng-container>
                        <!-- LAYER Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name</th>
                            <td mat-cell *matCellDef="let row"> {{row.getPrettyName()}} </td>
                        </ng-container>



                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type</th>
                            <td mat-cell *matCellDef="let row"> {{row.getCoverageType()}} </td>
                        </ng-container>

                        <!-- Progress Column -->
                        <ng-container matColumnDef="min_date">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Min date</th>
                            <td mat-cell *matCellDef="let row"> {{row.minDate | date :'MM/d/yyyy'}} </td>
                        </ng-container>
                        <!-- Progress Column -->
                        <ng-container matColumnDef="max_date">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Max date</th>
                            <td mat-cell *matCellDef="let row"> {{row.maxDate | date :'MM/d/yyyy'}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="orientations">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Orientations</th>
                            <td mat-cell *matCellDef="let row" style="text-align: center"> {{row.orientations}} </td>
                        </ng-container>

                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                                <div class="element-panel">
                                    <div class="element-detail">
                                        <div class="element-actions">
                                            <button matIconButton aria-label="Fit to extent" matTooltip="Fit to extent" (click)="fit(row)"><mat-icon>fit_screen</mat-icon></button>
                                            <button matIconButton aria-label="Paint coverage" matTooltip="Paint coverage" (click)="paint(row)"><mat-icon>draw</mat-icon></button>
                                            <button matIconButton aria-label="Copy wkt coverage" matTooltip="Copy coverage" (click)="copy(row)"><mat-icon>assignment</mat-icon></button>
                                            <button matIconButton aria-label="Show images" matTooltip="Show Images" (click)="showImagePanel(row)"><mat-icon>collections</mat-icon></button>
                                        </div>
<!--                                        <div class="element-info">-->
<!--                                            <div *ngFor="let item of row.layer?.aoi_properties | keyvalue">-->
<!--                                                <strong>{{item.key}}</strong>:{{item.value}}-->
<!--                                            </div>-->
<!--                                        </div>-->
                                    </div>


                                </div>
                            </td>
                        </ng-container>
                        <!-- Row shown when there is no matching data. -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                            class="element-row"
                            [class.expanded-row]="expandedElement === element"
                            (click)="expandedElement = expandedElement === element ? null : element"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                            class="detail-row"></tr>

                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data matching the filter {{input.value}}</td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                </div>
            </div>


        </div>
    </mat-card-content>
</mat-card>

<app-images-panel *ngIf="selected && showImages" [images]="selected.images" (closeEvent)="this.removeImagePanel()"  (paintCoverageEvent)="this.paintCoverageEvent.emit($event)"></app-images-panel>
